export default __webpack_public_path__ + "static/media/30.ace5e741.png";